const style = theme => ({})

export default style
